module.exports = __webpack_public_path__ + "img/7.d88daba1.jpg";